import {useContext} from "react";
import {DialogContext} from "../DialogProvider/DialogProvider";

export const useDialog = () => {
    return useContext(DialogContext);
};
